import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const confluentCloudContent = EntityContentBlueprint.make({
  name: 'confluent-cloud',
  params: {
    path: '/confluent',
    title: 'Confluent',
    group: 'operation',
    filter: entity =>
      entity.kind.toLocaleLowerCase('en-US') === 'component' &&
      Boolean(
        entity.metadata.annotations?.['confluent.com/cloud-environment-id'],
      ) &&
      Boolean(entity.metadata.annotations?.['confluent.com/cloud-cluster-id']),
    loader: () =>
      import('./ConfluentCloudContent').then(m => <m.ConfluentCloudContent />),
  },
});

export const confluentCloudModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [confluentCloudContent],
});
